/*
         * @ngdoc function
         * @name ePay.Model:Session_ValidationModel
         * @description
         * Model
         */

export class Session_ValidationModel {
  uid: string | null | undefined;
  status: string | null | undefined;
  mode: string | null | undefined;

	constructor(
		uid?: string, 
		status?: string, 
		mode?: string
	) {
		this.uid = uid || null;
		this.status = status || null;
		this.mode = mode || null;
	}
}
